import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-60708664")

_pushScopeId("data-v-60708664")
const _hoisted_1 = { class: "flex flex-col md:flex-row content-center justify-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DefaultBoostpackCardLayout = _resolveComponent("DefaultBoostpackCardLayout")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_DefaultBoostpackCardLayout, {
      "boostpack-description": _ctx.boostpackDescription,
      "boostpack-id": _ctx.boostpackId,
      "boostpack-reference": _ctx.boostpackReference,
      "boostpack-item-list": _ctx.boostpackItems,
      "boostpack-title": _ctx.boostpackTitle,
      "boostpack-creator": _ctx.boostpackCreator,
      "category-title": _ctx.categoryTitle
    }, null, 8, ["boostpack-description", "boostpack-id", "boostpack-reference", "boostpack-item-list", "boostpack-title", "boostpack-creator", "category-title"]), [
      [_vShow, _ctx.boostpack !== null]
    ]),
    _renderSlot(_ctx.$slots, "adsSlot")
  ]))
})